import React from 'react';

// Default export का उपयोग करें
const Tabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    'Active Pregnancies',
    'High Risk Cases', 
    'Due for ANC Visit',
    'Delivery Expected'
  ];

  return (
    <div className="tabs">
      {tabs.map((tab) => (
        <div
          key={tab}
          className={`tab ${activeTab === tab ? 'active' : ''}`}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </div>
      ))}
    </div> 
  );
};

export default Tabs; // यहाँ default export है